import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [ 
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  { path: '', loadChildren: './scheduleappointment/scheduleappointment.module#ScheduleappointmentPageModule' },
  {
    path: 'list',
    loadChildren: './list/list.module#ListPageModule'
  },
  { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
  { path: 'signup', loadChildren: './signup/signup.module#SignupPageModule' },
  { path: 'forgot', loadChildren: './forgot/forgot.module#ForgotPageModule' },
  { path: 'profile', loadChildren: './profile/profile.module#ProfilePageModule' },
  { path: 'findhealth', loadChildren: './findhealth/findhealth.module#FindhealthPageModule' },
  { path: 'scheduleappointment', loadChildren: './scheduleappointment/scheduleappointment.module#ScheduleappointmentPageModule' },
  { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardPageModule' },
  { path: 'myaccount', loadChildren: './myaccount/myaccount.module#MyaccountPageModule' },
  { path: 'editaccount', loadChildren: './editaccount/editaccount.module#EditaccountPageModule' },
  { path: 'changepassword', loadChildren: './changepassword/changepassword.module#ChangepasswordPageModule' },
  { path: 'patientdashboard', loadChildren: './patientdashboard/patientdashboard.module#PatientdashboardPageModule' },
  { path: 'officelocation', loadChildren: './officelocation/officelocation.module#OfficelocationPageModule' },
  { path: 'my-appointments', loadChildren: './my-appointments/my-appointments.module#MyAppointmentsPageModule' },
  { path: 'payment-option', loadChildren: './payment-option/payment-option.module#PaymentOptionPageModule' },
  { path: 'make-payment', loadChildren: './make-payment/make-payment.module#MakePaymentPageModule' },
  { path: 'thank-you', loadChildren: './thank-you/thank-you.module#ThankYouPageModule' },
  { path: 'view-appointment', loadChildren: './view-appointment/view-appointment.module#ViewAppointmentPageModule' },
  { path: 'fill-form', loadChildren: './fill-form/fill-form.module#FillFormPageModule' },
  { path: 'notification', loadChildren: './notification/notification.module#NotificationPageModule' },
  { path: 'officedetails', loadChildren: './officedetails/officedetails.module#OfficedetailsPageModule' },
  { path: 'videochat', loadChildren: './videochat/videochat.module#VideochatPageModule' },
  { path: 'videocall', loadChildren: './videocall/videocall.module#VideocallPageModule' },
  { path: 'incoming-call', loadChildren: './incoming-call/incoming-call.module#IncomingCallPageModule' },
  { path: 'all-appointments', loadChildren: './all-appointments/all-appointments.module#AllAppointmentsPageModule' },
  { path: 'test', loadChildren: './test/test.module#TestPageModule' },
  { path: 'view-policy', loadChildren: './view-policy/view-policy.module#ViewPolicyPageModule' },
  { path: 'doctor-appointments', loadChildren: './doctor-appointments/doctor-appointments.module#DoctorAppointmentsPageModule' },
  { path: 'rating', loadChildren: './rating/rating.module#RatingPageModule' },
  { path: 'faqs', loadChildren: './faqs/faqs.module#FaqsPageModule' },
  { path: 'privacy-policy', loadChildren: './privacy-policy/privacy-policy.module#PrivacyPolicyPageModule' },
  { path: 'calling', loadChildren: './calling/calling.module#CallingPageModule' },
  { path: 'view-text', loadChildren: './view-text/view-text.module#ViewTextPageModule' },
  { path: 'view-form', loadChildren: './view-form/view-form.module#ViewFormPageModule' },
  { path: 'view-filled-form', loadChildren: './view-filled-form/view-filled-form.module#ViewFilledFormPageModule' },
  { path: 'clientlist', loadChildren: './clientlist/clientlist.module#ClientlistPageModule' },
  { path: 'doctorlist', loadChildren: './doctorlist/doctorlist.module#DoctorlistPageModule' },
  { path: 'callingdoc', loadChildren: './callingdoc/callingdoc.module#CallingdocPageModule' },
  { path: 'messages', loadChildren: './messages/messages.module#MessagesPageModule' },
  { path: 'chat', loadChildren: './chat/chat.module#ChatPageModule' },
  { path: 'diary', loadChildren: './diary/diary.module#DiaryPageModule' },
  
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
